<template lang="pug">
  div
    v-avatar.avatar-shadow.mt-4.mb-8(size="100" color="info500")
      .text-xl.pa-4.white--text.font-semibold {{ totalStampCount }} {{ 'stamp' | pluralize({ count:totalStampCount }) }}
    .text-lg.font-semibold.mb-4 {{ member.name }} has achieved {{ totalStampCount }} {{ 'stamp' | pluralize({ count:totalStampCount }) }}!
</template>

<script>

export default {
  props: {
    member: {
      type: Object,
      required: true
    },
    postCollectedData: {
      type: Object,
      required: true
    },
  },
  computed: {
    totalStampCount() {
      return this.postCollectedData?.member?.collected || 0
    }
  },
}
</script>

<style scoped>
.avatar-shadow {
  box-shadow: 0 0 20px 18px rgba(163, 200, 255, 0.85);
  -webkit-box-shadow: 0 0 20px 18px rgba(163, 200, 255, 0.85);
  -moz-box-shadow: 0 0 20px 18px rgba(163, 200, 255, 0.85);
}
</style>